// src/util/eventBus.ts
var eventBus = {
  on: function on(event, callback) {
    document.addEventListener(event, callback);
  },
  off: function off(event, callback) {
    document.removeEventListener(event, callback);
  },
  dispatch: function dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, {
      detail: data
    }));
  }
};
export { eventBus };